
import ArrowRight from "vue-material-design-icons/ArrowRight";
import {
  flattenDashboardShortcutGroups,
  getAvailableDashboardShortcutGroups,
  getDashboardShortcutLocation,
  getSelectedDashboardShortcutIds,
  MAX_DASHBOARD_SHORTCUTS,
} from "../dashboardShortcuts";

export default {
  components: {
    ArrowRight,
  },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shortcutDraft: [],
      shortcutSearch: "",
      savingShortcuts: false,
      maxShortcuts: MAX_DASHBOARD_SHORTCUTS,
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser || {};
    },
    availableShortcutGroups() {
      return getAvailableDashboardShortcutGroups(
        this.currentUser?.recursos || []
      );
    },
    availableShortcuts() {
      return flattenDashboardShortcutGroups(this.availableShortcutGroups);
    },
    selectedShortcutIds() {
      return getSelectedDashboardShortcutIds(
        this.currentUser?.dashboard_shortcuts,
        this.availableShortcuts
      );
    },
    selectedShortcuts() {
      const shortcutsById = new Map(
        this.availableShortcuts.map((shortcut) => [shortcut.id, shortcut])
      );

      return this.selectedShortcutIds
        .map((id) => shortcutsById.get(id))
        .filter(Boolean);
    },
    normalizedSearch() {
      return this.normalizeSearchText(this.shortcutSearch);
    },
    filteredShortcutGroups() {
      if (!this.normalizedSearch) return this.availableShortcutGroups;

      return this.availableShortcutGroups.reduce((groups, group) => {
        const groupMatches = this.normalizeSearchText(group.name).includes(
          this.normalizedSearch
        );
        const shortcuts = groupMatches
          ? group.shortcuts
          : group.shortcuts.filter((shortcut) =>
              this.normalizeSearchText(shortcut.label).includes(
                this.normalizedSearch
              )
            );

        if (shortcuts.length) {
          groups.push({ ...group, shortcuts });
        }

        return groups;
      }, []);
    },
  },
  methods: {
    normalizeSearchText(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    navigateToShortcut(shortcutId) {
      this.$router.push(getDashboardShortcutLocation(shortcutId));
    },
    isShortcutDisabled(shortcutId) {
      return (
        this.shortcutDraft.length >= this.maxShortcuts &&
        !this.shortcutDraft.includes(shortcutId)
      );
    },
    openShortcutModal() {
      this.shortcutDraft = [...this.selectedShortcutIds];
      this.shortcutSearch = "";
      this.$bvModal.show("dashboard-shortcuts-modal");
    },
    onShortcutModalHidden() {
      this.shortcutSearch = "";
      this.shortcutDraft = [];
    },
    async saveShortcuts() {
      this.savingShortcuts = true;

      try {
        const { data } = await this.$http.post("/dashboard/shortcuts", {
          shortcuts: this.shortcutDraft,
        });
        const shortcuts = Array.isArray(data?.shortcuts)
          ? data.shortcuts
          : [...this.shortcutDraft];

        this.$set(this.currentUser, "dashboard_shortcuts", shortcuts);
        this.$bvModal.hide("dashboard-shortcuts-modal");
        this.$toast?.success?.("Atalhos do dashboard salvos!");
      } catch (_) {
        this.$toast?.error?.(
          "Não foi possível salvar os atalhos do dashboard."
        );
      } finally {
        this.savingShortcuts = false;
      }
    },
  },
};
